// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1c-hj","label":"Labeled_label__1_PWY","divider":"Labeled_divider__2ozL9"};